import { render, staticRenderFns } from "./tw_detail.vue?vue&type=template&id=594ca4e4&"
import script from "./tw_detail.vue?vue&type=script&lang=js&"
export * from "./tw_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports